import cx from 'classnames';
import TagId from '~/constants/common/TagId';
import { appAssetsCdnUrl } from '~/constants/environment';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import PriceTagIllustration from '~/icons/PriceTagIllustration';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './Cards.module.css';
import {
  CardContainer,
  CardCta,
  CardSubtitle,
  CardTitle,
  CardTitleContainer
} from './Cards.styles';

const GREAT_DEALS_SEARCH_LINK = generateSearchLinkFilter({
  filters: { tagIds: [TagId.GreatDeal.toString()] }
});

export default function GreatDealsCard() {
  const getHref = useGetConsumerHref();
  const backgroundImageUrl = optimizeImage(
    `${appAssetsCdnUrl}/images/home/budget-great-deals.png`,
    { height: 300, quality: 90, format: 'auto' }
  );

  return (
    <CardContainer
      className="relative bg-background-muted-subtle bg-contain bg-[center_bottom_74px] bg-no-repeat"
      data-analytics-id="Shop Great Deals"
      data-testid="great-deals-card"
      data-native-payload={nativeSrpPayload}
      href={getHref(GREAT_DEALS_SEARCH_LINK)}
      style={{
        backgroundImage: `url(${backgroundImageUrl})`
      }}
    >
      <CardTitleContainer>
        <CardTitle>Discover Great Deals!</CardTitle>
        <CardSubtitle>
          Cars priced $1,500 or more below the Kelley Blue Book® Typical
          Listing Price.
        </CardSubtitle>
      </CardTitleContainer>
      <PriceTagIllustration
        aria-hidden="true"
        className={cx('absolute left-[190px] top-[146px]', styles.priceTag)}
      />
      <CardCta data-testid="find-your-deal">Find Your Deal</CardCta>
    </CardContainer>
  );
}
